import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { ItemSearchComponent, GridEditComponent, ProductSearchComponent, TablePopupComponent, BarcodePrintComponent, TransactionhistoryComponent, DeleteitemComponent } from "../../../../../../shared";
import { SellingPriceEditComponent } from "../../../../../../shared/component/sellingprice-edit/sellingprice-edit.component"
import { DataService } from "../../../../../../shared/services/data.service";
import { InProductsService } from "../../../../../../shared/services/inventory/in-products.service";
import { InPurchasesService } from "../../../../../../shared/services/inventory/in-purchases.service";
import { MasterService } from "../../../../../../shared/services/inventory/master.service";
import { MainService } from "../../../../../../shared/services/main.service";
import { CaMasterService } from "../../../../../../shared/services/accounts/ca-master.service";
import { DialogService } from "../../../../../../shared/component/dialog/dialog.service";
import { IItemControl, IAlternateunit, IOrderLevel, IProduct_MasterView, ISellingPriceList, ISupplieritem, Product_MasterView_Model, Alternateunit_Model } from '../../../../../../shared/interface/Product_MasterView'
import { environment } from "../../../../../../../environments/environment";
import { PriceChangeComponent } from "../../../../../../shared/component/pricechange/pricechange.component";
import { ImageSelectComponent } from "../../../../../../shared/component/imageselect/imageselect.component";
import { HttpClient } from '@angular/common/http';

@Component({
  selector: "app-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.css"]
})

export class ProductComponent implements OnInit {
  constructor(
    private ds: DataService,
    private pds: InProductsService,
    private ms: MasterService,
    private main: MainService,
    private ips: InPurchasesService,
    private dialogService: DialogService,
    private cs: CaMasterService, private http: HttpClient
  ) {
  }

  @Input() Barcode: string;

  model: IProduct_MasterView;
  isEdit: boolean = false;
  isLoaded: boolean = false;
  isinitialLoad: boolean = true;
  Alternateunit: IAlternateunit

  departmentList: any;
  categorytList: any;
  subcategoryLtist: any;

  brandList: any;
  colorList: any;
  sizeList: any;
  unitList: any;
  supplierList: any;
  duplicate_Barcode_Model: any;
  branchList: any
  locationList: any;
  sellingPriceLevelList: any;
  MutipleSellingPriceEditable: boolean = false
  Access: any;
  taxcodelist: any
  PackingQty: string = "Packing Qty"
  yield: any = false
  fileToUpload: File = null;
  imageurl: string = "";
  EnableExpirydate: boolean = false;
  IsSerialItemEnable: boolean = false
  marginBasedonCostprice: boolean = false;
  AltCostUpdateAuto: boolean = false
  EnablePriceChange: boolean = false;
  VATExcludedMargin: boolean = false;
  RefNoDisableOnItemMaster: boolean = false;

  ImageUploaderValue: number = 0;
  @ViewChild("ImageUp") ImageUp: ElementRef;
  DefaultImage: string = ""
  AltImageUploaderValue: number = 0;
  @ViewChild("AltImageUp") AltImageUp: ElementRef;
  SelectedIndex: number = -1;
  SelectedRow: IAlternateunit;
  ImageUploadBasedOnApi: boolean = false;
  PromotionData:any="";
  CountiseriesBarcodeWeighingScaleitems:boolean=false;
  NoofBarcodeDigits:number=13;

  ngOnInit() {

    this.Access = this.ds.Access["Item Master"];

    this.MutipleSellingPriceEditable = !environment.MutipleSellingPriceEditable

    var isx = (this.ds.Settings.EnableExpirydate)
    this.EnableExpirydate = isx.toLowerCase() == 'true'

    var isser = (this.ds.Settings.ShowSerialNo)
    this.IsSerialItemEnable = isser.toLowerCase() == 'true'

    var marginBasedonCostprice = (this.ds.Settings.marginBasedonCostprice)
    this.marginBasedonCostprice = marginBasedonCostprice.toLowerCase() == 'true'

    var vt = (this.ds.Settings.VATExcludedMargin)
    this.VATExcludedMargin = vt.toLowerCase() == 'true'

    var AltCost = (this.ds.Settings.AltCostUpdateAuto)
    this.AltCostUpdateAuto = AltCost.toLowerCase() == 'true'

    var isx = (this.ds.Settings.EnablePriceChange)
    this.EnablePriceChange = isx.toLowerCase() == 'true'

    var fc = (this.ds.Settings.RefNoDisableOnItemMaster)
    this.RefNoDisableOnItemMaster = fc.toLowerCase() == 'true'

    this.PackingQty = this.ds.Settings.PackingQtyCaption;

    var im = (this.ds.Settings.ImageUploadBasedOnApi)
    this.ImageUploadBasedOnApi = im.toLowerCase() == 'true'

    var wbso=this.ds.Settings.CountiseriesBarcodeWeighingScaleitems;
    this.CountiseriesBarcodeWeighingScaleitems = wbso.toLowerCase() == 'true'

    this.NoofBarcodeDigits=Number(this.ds.Settings.NoofBarcodeDigits)

    this.newModels();
    this.LoadData();
    this.get_DefaultImage();
    if (this.Barcode) {
      this.model.Barcode = this.Barcode.toString();
      this.isLoaded = false;
      this.fillForBarcode();
    }
    else {
      this.ds.ComponentName = "Item Master";
    }

    this.isLoaded = true;
  }

  LoadData() {
    this.isLoaded = false;
    this.getDepartment()
    if (this.isEdit) {

    } else {
      this.getItemId();
    }
    this.isLoaded = true;
  }

  newModels() {
    this.model = new Product_MasterView_Model();
    this.Alternateunit = new Alternateunit_Model();
    this.isEdit = false;
    this.LoadData();
    document.getElementById("Barcode").focus();
    this.duplicate_Barcode_Model = {
      Barcode: [],
      ItemTypeId: this.ds.Settings.ItemTypeId,
      isEdit: this.isEdit
    }
    this.Get_BranchList();
    this.Get_LocationsList();
    this.Get_SellingPriceList();
    this.getTaxcode()
    this.ImageUploaderValue = 0;
    this.model.ItemImagepath = this.DefaultImage;
    this.imageurl = this.DefaultImage;
    this.AltImageUploaderValue = 0;
    this.Alternateunit.itemimagePath = this.DefaultImage;
    this.SelectedIndex = -1;
    this.SelectedRow = new Alternateunit_Model();
    this.PromotionData="";
  }

  listBarcode() {
    let d = this.dialogService
      .addDialog(ProductSearchComponent, { title: "Item search", message: "" })
      .subscribe(res => {
        if (res.result) {
          this.newModels();
          this.model.Barcode = res.item.Barcode;
          document.getElementById("Barcode").focus();
        }
      });
  }

  barcodeKeydown(e) {
    if (e.keyCode == 115 && e.which == 115) {
      let d = this.dialogService
        .addDialog(ItemSearchComponent, { title: "Item search", message: "" })
        .subscribe(res => {
          if (res.result) {
            this.newModels();
            this.model.Barcode = res.item.Barcode;
            document.getElementById("Barcode").focus();
          }
        });
    } else if (e.keyCode == 13 && e.which == 13) {
      if (this.model.Barcode != "") {
        this.isLoaded = false;
        this.fillForBarcode();
      }
    }
    else if (e.altKey && e.keyCode == 71 && e.which == 71) {
      this.itemMasterBarcode()
    }
  }
  validateEdit(i): boolean {
    if (i.Conversion.trim() == "" || i.Description.trim() == "") {
      alert("Make sure all Mandatory fields are Filled");
      return false;
    } else if (Number(i.Conversion) < 0 || Number(i.Conversion) == 0) {
      alert("Conversion Amount Not Valid");
      return false
    } else if (Number(i['Selling Price']) < Number(i['Cost Price'])) {
      if (confirm("Selling price is Lesser than CostPrice \nDo you want to Save this Record?")) {
        return true;
      } else {
        return false
      }
    } else {
      return true;
    }
  }
  selectItem(i) {
    var item = i;
    var items = [
      { Name: "Barcode", Type: "text", Value: item.barcode, Readonly: true, Calc: true, exp: "" },
      { Name: "Unit", Type: "select", Value: item.unitid, Readonly: true, Calc: false, exp: "", List: this.unitList },
      { Name: "Conversion", Type: "number", Value: item.conversion, Readonly: false, Calc: false, exp: "" },
      { Name: "Cost Price", Type: "number", Value: Number(item.costprice).toFixed(environment.noofdecimal), Readonly: false, Calc: false, exp: "" },
      { Name: "Selling Price", Type: "number", Value: Number(item.sellingprice).toFixed(environment.noofdecimal), Readonly: false, Calc: false, exp: "" },
      { Name: "Description", Type: "text", Value: item.description, Readonly: false, Calc: false, exp: "" },
      { Name: "Sec.Language", Type: "text", Value: item.secondarylanguagename, Readonly: false, Calc: false, exp: "" }
    ];
    let d = this.dialogService
      .addDialog(GridEditComponent, {
        title: "Edit ",
        Items: items,
        allowDelete: false
      })
      .subscribe(res => {
        if (res.result) {
          var r = res.RtnItem;
          if (this.validateEdit(res.RtnItem)) {
            item.conversion = r.Conversion;
            item.costprice = r['Cost Price'];
            item.sellingprice = r['Selling Price'];
            item.description = r.Description;
            item.secondarylanguagename = r['Sec.Language'];
            item.unitid = r['Unit'];
            item.Unit = this.unitNameById(item.unitid);
          }
        }
      });
  }
  deptCode(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.GetDeptByCode(this.model.ItemCode);
    }
  }
  deptLeave(e) {
    this.GetDeptByCode(this.model.ItemCode, false);
  }
  margin() {
    if (this.model.CostPrice == null || (this.model.CostPrice).toString() == "" || (this.model.CostPrice).toString() == ".") {
      this.model.CostPrice = 0.00;
    }
    if (this.model.SellingPrice == null || (this.model.SellingPrice).toString() == "" || (this.model.SellingPrice).toString() == ".") {
      this.model.SellingPrice = 0.00;
    }
    this.model.CostPrice = Number(parseFloat(this.model.CostPrice.toString()).toFixed(environment.noofdecimal));
    this.model.SellingPrice = Number(parseFloat(this.model.SellingPrice.toString()).toFixed(environment.noofdecimal));

    this.calculateMargin();

    if (this.model.Alternateunit.length > 0 && this.AltCostUpdateAuto) {
      for (let i of this.model.Alternateunit) {
        i.costprice = Number(i.conversion) * this.model.CostPrice;
      }
    }

    try {
      this.model.SellingPriceList.find(x => x.barcode == this.model.Barcode && x.sellingpricelevelid == this.ds.Settings.SellingPriceLevelId).sellingprice = this.model.SellingPrice
    } catch (ex) { }

  }
  calculateMargin() {
    try {

      if (this.VATExcludedMargin) {
        this.model.Margin = (this.model.SellingPrice - (this.model.SellingPrice * (this.model.TaxRate / 100)) - this.model.CostPrice)
        if (this.marginBasedonCostprice) {
          if (this.model.CostPrice != 0) {
            this.model.MarginPer = Math.abs((((this.model.SellingPrice - (this.model.SellingPrice * (this.model.TaxRate / 100)) - this.model.CostPrice) / this.model.CostPrice) * 100))
          } else {
            this.model.MarginPer = 0;
          }
        }
        else {
          if (this.model.SellingPrice != 0) {
            this.model.MarginPer = Math.abs((((this.model.SellingPrice - (this.model.SellingPrice * (this.model.TaxRate / 100)) - this.model.CostPrice) / this.model.SellingPrice) * 100))
          } else {
            this.model.MarginPer = 0;
          }
        }
      }
      else {
        if (this.ds.Settings.VATMarginOn == 1) {
          var n_price: number = 0
          n_price = (this.model.SellingPrice / (1 + (this.model.TaxRate / 100)))
          this.model.Margin = Number(parseFloat((n_price - this.model.CostPrice).toString()).toFixed(environment.noofdecimal));
          if (!this.marginBasedonCostprice) {
            if (n_price != 0) {
              this.model.MarginPer = Math.abs(((this.model.Margin / n_price) * 100))
            } else {
              this.model.MarginPer = 0;
            }
          }
        }
        else {
          this.model.Margin = Number(parseFloat((this.model.SellingPrice - this.model.CostPrice).toString()).toFixed(environment.noofdecimal));
          if (this.marginBasedonCostprice) {
            if (this.model.CostPrice != 0) {
              this.model.MarginPer = Math.abs((this.model.Margin / this.model.CostPrice) * 100)
            } else {
              this.model.MarginPer = 0;
            }
          }
          else {
            if (this.model.SellingPrice != 0) {
              this.model.MarginPer = Math.abs((this.model.Margin / this.model.SellingPrice) * 100)
            } else {
              this.model.MarginPer = 0;
            }
          }
        }

      }
    }
    catch (ex) {
      this.model.MarginPer = 0;
    }
  }

  clearProduct() {
    this.newModels();
  }
  AlterPriceCalc() {
    this.Alternateunit.costprice = (Number(this.Alternateunit.conversion) * this.model.CostPrice)
    this.Alternateunit.sellingprice = (Number(this.Alternateunit.conversion) * this.model.SellingPrice)
    this.Alternateunit.description = this.model.Name.substring(0, 15);
  }
  SelectUnit(e) {
    this.Alternateunit.Unit = e.Name;
    this.Alternateunit.unitid = e.Id;
    document.getElementById("Dconversion").focus();
  }
  validateDuplicate(i): boolean {
    if (i.barcode.trim() == "" || i.conversion.trim() == "" || i.description.trim() == "" || i.unitid == 0) {
      alert("Make sure all Mandatory fields are Filled");
      return true;
    } else if (Number(i.conversion) < 0 || Number(i.conversion) == 0) {
      alert("Conversion Amount Not Valid");
      return true
    } else if (Number(i.sellingprice) < Number(i.costprice)) {
      if (confirm("Selling price is Lesser than CostPrice \nDo you want to Save this Record?")) {
        return false;
      } else {
        return true
      }
    }
  }
  addAlternateUnits(e) {
    if (e.keyCode == 13 && e.which == 13) {
      if (this.validateDuplicate(this.Alternateunit)) {
        return false
      }
      var data = false;
      this.duplicate_Barcode_Model.Barcode = [];
      this.duplicate_Barcode_Model.isEdit = false;
      this.duplicate_Barcode_Model.Barcode.push(this.Alternateunit.barcode.trim());
      this.pds.checkBarcodeDuplicate(this.duplicate_Barcode_Model).subscribe(res => {
        if (res.Success) {
          data = res.data;
        } else {
          data = true;
        }
      }, (err) => console.error(err),
        () => {
          var barcode = [];
          barcode.push(this.model.Barcode)
          for (let i of this.model.Alternateunit) {
            barcode.push(i.barcode);
          }

          if (barcode.indexOf(this.Alternateunit.barcode) == -1) {
            if (!data) {
              this.model.Alternateunit.push(this.Alternateunit);
              this.Alternateunit = new Alternateunit_Model();
              this.Alternateunit.itemimagePath = this.DefaultImage;
              document.getElementById("altunit").focus();
            } else {
              alert("Barcode Already Exist")
            }
          } else {
            alert("Barcode Already Exist")
          }
        }
      )
    } else if (e.altKey && e.keyCode == 71 && e.which == 71) {
      this.AlternativeBarcode()
    }
  }

  //-------------------------- All Data Load -----------------------------

  fillForBarcode() {
    var FilterBarcode = {
      ItemType: this.ds.Settings.ItemTypeId,
      Barcode: this.model.Barcode,
      SellingPriceLevel: this.ds.Settings.SellingPriceLevelId,
      Branch: this.ds.Settings.BranchId,
      Location: this.ds.Settings.LocationId
    };

    this.pds.Get_ProductByBarcode(FilterBarcode).subscribe(res => {
      if (res.Success) {
        this.isEdit = true;
        this.model = Object.assign({}, res.data);
        const a = Object.assign({}, res.data);
        this.get_BarcodeOtherDetails(res.data.Id);
      } else {
        this.isEdit = false
        document.getElementById("ItemCode").focus();
      }

    }, (err) => console.error(err),
      () => {
        this.isLoaded = true;
        this.Fill_AtributesByBarcode();
      })
  }
  Fill_AtributesByBarcode() {
    var d = {
      ItemType: this.ds.Settings.ItemTypeId,
      Barcode: this.model.Barcode,
      SellingPriceLevel: this.ds.Settings.SellingPriceLevelId,
      Branch: this.ds.Settings.BranchId,
      Location: this.ds.Settings.LocationId,
      ItemId: this.model.Id
    }
    this.pds.Get_AtributesByBarcode(d).subscribe(res => {
      if (res.Success) {
        this.model.StkQty = res.data.StkQty
        this.model.AvgCost = res.data.AvgCost
        this.model.LastPurCost = res.data.LastPurCost
        this.model.Margin = res.data.Margin
        this.model.MarginPer = res.data.MarginPer
      }
    }, (err) => { }, () => {
      this.margin();
    })
  }
  getDepartment() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.pds.getDepartment(FilterData).subscribe(res => {
      this.departmentList = [];
      for (let i of res.data) {
        this.departmentList.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name
        });
      }
    },
      (err) => console.error(err),
      () => {
        this.getCategory()
      });
  }

  getCategory() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.pds.getCategory(FilterData).subscribe(res => {
      this.categorytList = [];
      for (let i of res.data) {
        this.categorytList.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name
        });
      }
    },
      (err) => console.error(err),
      () => {
        this.getSubcategory();
      }
    );
  }

  getSubcategory() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.pds.getSubcategory(FilterData).subscribe(res => {
      this.subcategoryLtist = [];
      for (let i of res.data) {
        this.subcategoryLtist.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name,
          Code: i.Code
        });
      }
    }, (err) => console.error(err),
      () => {
        this.getBrands();
      }
    );
  }
  getBrands() {
    var filterData = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.ms.getBrand(filterData).subscribe(
      res => {
        this.brandList = [];
        for (let i of res.data) {
          this.brandList.push({
            Id: i.Id,
            Name: i.Name
          });
        }
      },
      (err) => console.error(err),
      () => {
        this.getSupplier();
      }
    );
  }
  getSupplier() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.ips.getSupplierForItemMaster(FilterData).subscribe(res => {
      this.supplierList = [];
      for (let i of res.data) {
        this.supplierList.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name
        });
      }
    }, (err) => console.error(err),
      () => {
        this.getUnits();
      }
    );
  }

  getUnits() {
    var filterData = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.ms.GetUnit(filterData).subscribe(
      res => {
        this.unitList = [];
        for (let i of res.data) {
          this.unitList.push({
            Id: i.Id,
            Name: i.Name
          });
        }
      },
      (err) => console.error(err),
      () => {
        this.getColor();
      }
    );
  }

  getColor() {
    var filterData = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.ms.getColour(filterData).subscribe(
      res => {
        this.colorList = [];
        for (let i of res.data) {
          this.colorList.push({
            Id: i.Id,
            Name: i.Name
          });
        }
      },
      (err) => console.error(err),
      () => {
        this.getSize();
      }
    );
  }
  getSize() {
    var filterData = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: 1,
      CAType: 1
    };
    this.ms.getSize(filterData).subscribe(
      res => {
        this.sizeList = [];
        for (let i of res.data) {
          this.sizeList.push({
            Id: i.Id,
            Name: i.Name
          });
        }
      },
      (err) => console.error(err),
      () => {
        this.isLoaded = true;
      }
    );
  }
  getItemId() {
    this.pds.getItemId().subscribe(res => {
      if (res.Success) {
        this.model.Id = res.data;
        this.model.ItemType = this.ds.Settings.ItemTypeId;
      }
    },
      (err) => console.error(err),
      () => { });
  }

  itemMasterBarcode() {
    this.pds.getItemId().subscribe(res => {
      if (res.Success) {
        this.model.Id = res.data;
        this.model.ItemType = this.ds.Settings.ItemTypeId;
      }
    },
      (err) => console.error(err),
      () => {
        var model_barcodeGen = {
          IID: this.model.Id,
          NoofBarcodeDigits: this.NoofBarcodeDigits,
          itemMasterStartNo: this.ds.Settings.ItemmasterStartNo.toString(),
          UserNo: this.ds.Settings.UserNo.toString(),
          itemMasterTypeID: this.ds.Settings.ItemTypeId,
          WeighingScaleitems: this.model.IsWeightItem,
          isMasterItem: true,
          ItemCount: 0,
          BarcodeSeriesOrder:this.CountiseriesBarcodeWeighingScaleitems
        };
        this.pds.GenBarcode(model_barcodeGen).subscribe(res => {
          this.model.Barcode = res.data;
          document.getElementById("ItemCode").focus();
        })
      });
  }
  AlternativeBarcode() {
    var model_barcodeGen = {
      IID: this.model.Id,
      NoofBarcodeDigits: this.NoofBarcodeDigits,
      itemMasterStartNo: this.ds.Settings.ItemmasterStartNo.toString(),
      UserNo: this.ds.Settings.UserNo.toString(),
      itemMasterTypeID: this.ds.Settings.ItemTypeId,
      WeighingScaleitems: this.model.IsWeightItem,
      isMasterItem: false,
      ItemCount: this.model.Alternateunit.length
    };
    this.pds.GenBarcode(model_barcodeGen).subscribe(res => {
      this.Alternateunit.barcode = res.data;
    })
  }
  GetDeptByCode(code, enterkey = true) {
    var data = {
      Code: code,
      ItemType: this.ds.Settings.ItemTypeId
    }
    this.pds.GetDeptByCode(data).subscribe(res => {
      if (res.Success) {
        this.model.DeptId = res.data.DeptId
        this.model.CatId = res.data.CatId
        this.model.SubCatId = res.data.SubCatId
        this.model.ItemCode = res.data.Code + this.pad(this.model.Id, 4)
        if (enterkey) {
          document.getElementById("Name").focus();
        }
      }
      else {
        alert(res.UserMsg)
      }
    },
      (err) => console.error(err),
      () => {

      });
  }
  SelectedDept(e) {
    var deptFilter = {
      DeptId: e.Id,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: 1,
        CAType: 1
      }
    };
    this.pds.getCategoryByDept(deptFilter).subscribe(res => {
      this.categorytList = [];
      this.model.CatId = 0
      this.subcategoryLtist = [];
      this.model.SubCatId = 0
      for (let i of res.data) {
        this.categorytList.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name,
          Code: i.Code
        });
      }
      document.getElementById("CatId").focus();
    });
  }
  SelectedCate(e) {
    var deptFilter = {
      DeptId: e.Id,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: 1,
        CAType: 1
      }
    };
    this.pds.getSubCategoryBycat(deptFilter).subscribe(res => {
      this.subcategoryLtist = [];
      this.model.SubCatId = 0;
      for (let i of res.data) {
        this.subcategoryLtist.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name,
          Code: i.Code
        });
      }
      document.getElementById("SubCatId").focus();
    },
      (err) => console.error(err),
      () => {

      });
  }
  saveProduct() {
    this.model.ItemImageBinary = new Object
    this.isLoaded = false;
    this.pds.saveProduct(this.model).subscribe(res => {

      if (res.Success) {
        alert(res.UserMsg.Message)
        this.fillForBarcode();
        this.SelectedRow = new Alternateunit_Model();
        this.Alternateunit.itemimagePath = this.DefaultImage;
        this.SelectedIndex = -1;
      } else {
        alert(res.error.UsrMsg);
        this.isLoaded = true;
      }
    })
  }
  updaateProduct() {
    this.model.ItemImageBinary = new Object
    this.pds.UpdateProduct(this.model).subscribe(res => {
      if (res.Success) {
        alert(res.UserMsg.Message)
        this.SelectedRow = new Alternateunit_Model();
        this.Alternateunit.itemimagePath = this.DefaultImage;
        this.SelectedIndex = -1;
        this.fillForBarcode();
      }
      else {
        alert(res.error.UsrMsg);
        this.isLoaded = true;
      }
    })
  }

  Get_BranchList() {

    var data = {
      Start: 0,
      FiterText: '',
      Limit: 100,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    }

    this.main.Get_BranchForTree(data).subscribe(res => {

      if (res.Success) {
        this.branchList = res.data;
      }
    })
  }
  Get_LocationsList() {
    var data = {
      CompanyId: 1,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: 100,
        ItemTypeId: 1,
        CAType: 1
      }
    }
    this.main.GetLocationByCompany(data).subscribe(res => {
      if (res.Success) {
        this.locationList = res.data;

      }
    })
  }
  Get_SellingPriceList() {
    var data = {
      CompanyId: 1,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: 100,
        ItemTypeId: 1,
        CAType: 1
      }
    }
    this.pds.GetSellingPriceLevelByComapny(data).subscribe(res => {
      if (res.Success) {
        this.sellingPriceLevelList = res.data;
      }
    })
  }
  //--------------------------
  LoadItemControl(locid): IItemControl[] {
    var items: IItemControl[] = []
    var allowpurchase = true;
    var allowsales = true;
    var allowtransin = true;
    var allowtransout = true;
    for (let it of this.locationList) {
      items.push({ ID: 0, barcode: this.model.Barcode, locationid: it.Id, allowpurchase: allowpurchase, allowsales: allowsales, allowtransin: allowtransin, allowtransout: allowtransout })
      for (let i of this.model.Alternateunit) {
        items.push({ ID: 0, barcode: i.barcode, locationid: it.Id, allowpurchase: allowpurchase, allowsales: allowsales, allowtransin: allowtransin, allowtransout: allowtransout })
      }
    }
    return items
  }
  LoadItemOrderLevel(locid): IOrderLevel[] {
    var items: IOrderLevel[] = []
    for (let i of this.locationList) {
      items.push({ ID: 0, barcode: this.model.Barcode, location: i.Id, minimumlevel: 0, reorderlevel: 0, reorderqty: 0 })
    }
    return items
  }
  LoadSupplierItem(BranchId): ISupplieritem[] {
    var items: ISupplieritem[] = []
    if (this.isEdit) {
      items.push({ ID: 0, barcode: this.model.Barcode, branchid: this.ds.Settings.BranchId, costprice: this.model.CostPrice, supplierid: this.model.supplier, supplieritemcode: this.model.RefNo })
      for (let i of this.model.Alternateunit) {
        if(i.ID==0){
          for (let it of this.branchList) {
              items.push({ ID: 0, barcode: i.barcode, branchid: it.Id, costprice: i.costprice, supplierid: this.model.supplier, supplieritemcode: this.model.RefNo })
          }
        }
        else{
          items.push({ ID: 0, barcode: i.barcode, branchid: this.ds.Settings.BranchId, costprice: i.costprice, supplierid: this.model.supplier, supplieritemcode: this.model.RefNo })
        }     
      }
    }
    else {
      for (let it of this.branchList) {
        items.push({ ID: 0, barcode: this.model.Barcode, branchid: it.Id, costprice: this.model.CostPrice, supplierid: this.model.supplier, supplieritemcode: this.model.RefNo })
        for (let i of this.model.Alternateunit) {
          items.push({ ID: 0, barcode: i.barcode, branchid: it.Id, costprice: i.costprice, supplierid: this.model.supplier, supplieritemcode: this.model.RefNo })
        }
      }
    }
    return items
  }
  LoadSellingPriceMaster(SellingPriceLevel): ISellingPriceList[] {
    var items: ISellingPriceList[] = []
    if (this.model.SellingPriceList.length == 0) {
      for (let it of this.sellingPriceLevelList) {
        items.push({ ID: 0, barcode: this.model.Barcode, sellingprice: this.model.SellingPrice, sellingpricelevelid: it.LevelId })
        for (let i of this.model.Alternateunit) {
          items.push({ ID: 0, barcode: i.barcode, sellingprice: i.sellingprice, sellingpricelevelid: it.LevelId })
        }
      }
    }
    else {
      items = this.model.SellingPriceList;
      for (let it of this.sellingPriceLevelList) {
        for (let i of this.model.Alternateunit) {
          if (!items.find(x => x.barcode == i.barcode && x.sellingpricelevelid == it.LevelId)) {
            items.push({ ID: 0, barcode: i.barcode, sellingprice: i.sellingprice, sellingpricelevelid: it.LevelId })
          } else {
            if (it.LevelId == SellingPriceLevel) {
              items.find(x => x.barcode == i.barcode && x.sellingpricelevelid == it.LevelId).sellingprice = i.sellingprice
            }
          }
        }
      }
    }
    return items
  }

  LoadAtributsProduct() {
    this.model.ItemControl = this.LoadItemControl(1);
    this.model.OrderLevel = this.LoadItemOrderLevel(1);
    this.model.Supplieritem = this.LoadSupplierItem(1);
    this.model.SellingPriceList = this.LoadSellingPriceMaster(this.ds.Settings.SellingPriceLevelId);
  }
  validationCheck(): boolean {
    this.model.ImageHeight = this.ds.Settings.Height;
    this.model.ImageWidth = this.ds.Settings.Width;

    if (this.model.Barcode.trim() == "" || this.model.CatId == 0 || this.model.DeptId == 0 || this.model.SubCatId == 0 || this.model.supplier == 0 || this.model.Name.trim() == "" || this.model.ItemCode.trim() == "" || this.model.UnitId == 0 || this.model.Taxcode == 0) {
      alert("Make sure all Mandatory fields are Filled");
      return false;
    }
    this.LoadAtributsProduct();
    if (this.model.SellingPrice == 0 && this.model.CostPrice == 0) {
      if (confirm("Selling price and CostPrice is Zero \nDo you want to Save this Record?")) {
        return true;
      } else {
        return false
      }
    }
    else if (this.model.CostPrice == 0) {
      if (confirm("Cost Price is Zero \nDo you want to Save this Record?")) {
        return true;
      } else {
        return false
      }
    } else if (this.model.SellingPrice == 0) {
      if (confirm("Selling price is Zero \nDo you want to Save this Record?")) {
        return true;
      } else {
        return false
      }
    }
    else if (Number(this.model.SellingPrice) < Number(this.model.CostPrice)) {
      if (confirm("Selling price is Lesser than CostPrice \nDo you want to Save this Record?")) {
        return true;
      } else {
        return false
      }
    } else {
      return true;
    }
  }
  saveUpdateProduct() {
    if (this.validationCheck()) {
      this.isLoaded = false;
      if (this.isEdit) {
        this.updaateProduct();
      } else {
        this.saveProduct();
      }
    }
  }

  genItemCode(e) {
    this.GetDeptByCode(e.Code, false);
    document.getElementById("Brand").focus();
  }
  focusRefNo() {
    document.getElementById("RefNo").focus();
  }

  pad(num, size) {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }
  saveEditAccessPremission(Access: any, edit: boolean): boolean {
    Access = this.ds.Access["Item Master"];
    if (edit) {
      return !Access.edit
    }
    else {
      return !Access.save
    }
  }
  selectFocus(elementId) {
    document.getElementById(elementId).focus();
  }
  itemnameKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("ShortName").focus();
    }
  }
  shortnameKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("seclanguage").focus();
    }
  }
  seclanguageKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("DeptId").focus();
    }
  }
  refnoKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("unit").focus();
    }
  }
  packingqtyKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("costprice").focus();
    }
  }
  costpriceKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.margin();
      document.getElementById("sellingprice").focus();
    }
  }
  sellingpriceKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.margin();
      document.getElementById("TaxCode").focus();
    }
  }

  conversionpriceKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      if (this.Alternateunit.unitid == 0) {
        document.getElementById("Dunitid").focus();
      }
      else if (this.Alternateunit.conversion == "") {
        document.getElementById("Dconversion").focus();
      }
      else {
        document.getElementById("Dcostprice").focus();
        this.SelectedRow = new Alternateunit_Model();
        this.Alternateunit.itemimagePath = this.DefaultImage;
        this.SelectedIndex = -1;
      }
    }
  }
  altcostKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {

      this.altcostpriceLeave();
      document.getElementById("altsellprice").focus();
    }
  }
  altsellpriceKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.altsellingpriceLeave();
      document.getElementById("altname").focus();
    }
  }
  altnameKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      if (this.Alternateunit.conversion == "") {
        document.getElementById("Dconversion").focus();
      }
      else if (this.Alternateunit.description == "") {
        document.getElementById("altname").focus();
      }
      else {
        document.getElementById("altseclang").focus();
      }
    }
  }
  altseclangKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("altbarcode").focus();
    }
  }
  unitNameById(id): string {
    try {
      return this.unitList.find(x => x.Id == id).Name;
    } catch (ex) {
      return ""
    }
  }
  altcostpriceLeave() {
    if (this.Alternateunit.costprice == null || (this.Alternateunit.costprice).toString() == "" || (this.Alternateunit.costprice).toString() == ".") {
      this.Alternateunit.costprice = 0.00;
    }
    this.Alternateunit.costprice = Number(parseFloat(this.Alternateunit.costprice.toString()).toFixed(environment.noofdecimal));
  }
  altsellingpriceLeave() {
    if (this.Alternateunit.sellingprice == null || (this.Alternateunit.sellingprice).toString() == "" || (this.Alternateunit.sellingprice).toString() == ".") {
      this.Alternateunit.sellingprice = 0.00;
    }
    this.Alternateunit.sellingprice = Number(parseFloat(this.Alternateunit.sellingprice.toString()).toFixed(environment.noofdecimal));
  }

  PriceChage() {
    this.LoadAtributsProduct();
    var col = [
      { field: 'Barcode', header: 'Barcode', t: 'text', e: false },
      { field: 'Name', header: 'Name', t: 'text', e: false },
      { field: 'Unit', header: 'Unit', t: 'text', e: false }
    ]

    var items = [];
    var m = this.model;
    var mr = { Barcode: m.Barcode, Name: m.Name, Unit: this.unitNameById(m.UnitId) };
    for (let i of this.sellingPriceLevelList) {
      col.push({ field: i.LevelId, header: i.LevelName, t: 'decimal', e: true })
      mr[i.LevelId] = this.PriceOfLevel(m.Barcode, i.LevelId)
    }
    items.push(mr)
    for (let i of m.Alternateunit) {
      var dr = { Barcode: i.barcode, Name: i.description, Unit: i.Unit }
      for (let it of this.sellingPriceLevelList) {
        dr[it.LevelId] = this.PriceOfLevel(i.barcode, it.LevelId)
      }
      items.push(dr)
    }

    let d = this.dialogService
      .addDialog(TablePopupComponent, { title: "Price Level", Items: items, Cols: col })
      .subscribe(res => {
        if (res.result) {
          for (let i of this.model.SellingPriceList) {
            var x = i.sellingprice = res.RtnItem.find(x => x.Barcode == i.barcode)[i.sellingpricelevelid];
            i.sellingprice = Number(parseFloat(x).toFixed(environment.noofdecimal))
          }
          for (let i of this.model.Alternateunit) {
            i.sellingprice = res.RtnItem.find(x => x.Barcode == i.barcode)[this.ds.Settings.SellingPriceLevelId];
          }
          this.model.SellingPrice = res.RtnItem.find(x => x.Barcode == this.model.Barcode)[this.ds.Settings.SellingPriceLevelId];
          this.margin();
        }
      });
  }
  PriceOfLevel(barcode, level): number {
    try {
      if (this.ds.Settings.SellingPriceLevelId == level) {
        try {
          return this.model.Alternateunit.find(x => x.barcode == barcode).sellingprice
        } catch (ex) {

        }
      }
      return this.model.SellingPriceList.find(x => x.barcode == barcode && x.sellingpricelevelid == level).sellingprice;
    } catch (ex) {
      return 0;
    }
  }
  BarcodePrint() {

    var items = [];
    var m = this.model;
    items.push({ Selected: false, Barcode: m.Barcode, Name: m.Name, Unit: this.unitNameById(m.UnitId), Rate: m.SellingPrice, Copeis: 1 })
    for (let i of m.Alternateunit) {
      items.push({ Selected: false, Barcode: i.barcode, Name: i.description, Unit: i.Unit, Rate: i.sellingprice, Copeis: 1 })
    }
    let d = this.dialogService
      .addDialog(BarcodePrintComponent, { title: "Barcode Print", Items: items })
      .subscribe(res => {
        if (res.result) {

        }
      });
  }
  getTaxcode() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    };
    this.cs.GetTaxcode(FilterData).subscribe(res => {
      this.taxcodelist = [];
      for (let i of res.data) {
        this.taxcodelist.push({
          Id: i.Id,
          Name: i.TaxCode,
        });
      }
      if (this.taxcodelist.length > 0) {
        this.model.Taxcode = this.taxcodelist[0].Id
      }

    },
      (err) => console.error(err),
      () => {
        this.getTaxRate(this.model.Taxcode);
      }
    );
  }
  getTaxRate(e) {
    this.cs.GetTaxratebytaxcode(e).subscribe(res => {
      if (res.Success) {
        this.model.TaxRate = res.data.TaxRate;
      }
    },
      (err) => console.error(err),
      () => { }
    );
  }
  getTaxcodechange(e) {
    this.cs.GetTaxratebytaxcode(e.Id).subscribe(res => {
      if (res.Success) {
        this.model.TaxRate = res.data.TaxRate;
        this.calculateMargin();
      }
      else {
        this.model.TaxRate = 0;
        this.calculateMargin();
      }
    },
      (err) => console.error(err),
      () => { }
    );

    document.getElementById("altunit").focus();
  }
  history() {
    var items: any;
    items = this.model;
    let d = this.dialogService
      .addDialog(TransactionhistoryComponent, {
        title: "Product History", data: this.model,
      })
  }
  deleteItem() {
    var items: any;
    items = this.model;
    let d = this.dialogService
      .addDialog(DeleteitemComponent, {
        title: "Delete Item",
      })
  }
  translate() {
    var textfilter: any = {
      Text: this.model.Name,
      ToLang: ""
    }
    this.pds.Translate(textfilter).subscribe(res => {
      if (res.Success) {
        this.model.SecLanguage = res.data
      }
    }
    )
  }

  UpdatePrice() {
    let d = this.dialogService
      .addDialog(SellingPriceEditComponent, { title: "Update Selling Price", Barcode: this.model.Barcode })
      .subscribe(res => {
        if (res.result) {
          this.get_NewPrice();
        }
      });
  }

  get_NewPrice() {
    var data = {
      Barcode: this.model.Barcode,
      Id: 1
    }
    this.isLoaded = false;
    this.pds.Get_SellingPriceByBarcode(data).subscribe(res => {
      if (res.Success) {
        document.getElementById("TaxCode").focus();
        this.model.SellingPrice = res.data.SellingPrice;
        this.margin();
        this.isLoaded = true;
      }
      else {
        this.isLoaded = true;
      }
    })
  }

  ChangePrice() {
    if (this.model.Barcode != "" && this.isEdit) {
      var data = {
        Barcode: this.model.Barcode,
        ItemName: this.model.Name
      }
      let d = this.dialogService
        .addDialog(PriceChangeComponent, { title: "Update Price", Items: data })
        .subscribe(res => {
          if (res.result) {
            this.fillForBarcode();
          }
        });
    }
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = <File>files.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageurl = event.target.result;
      this.model.ItemImagepath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }

  ImageUploaderChange(e) {
    if (this.ImageUploaderValue == 1) {
      this.ImageUp.nativeElement.value = "";
      this.ImageUp.nativeElement.click();
    }
    else if (this.ImageUploaderValue == 2) {
      this.get_ImageOnFetchOne(true);
    }
    else if (this.ImageUploaderValue == 3) {
      this.get_ImagesOnFetchImages(true);
    }
    else if (this.ImageUploaderValue == 4) {
      this.model.ItemImagepath = this.DefaultImage;
      this.imageurl = this.DefaultImage;
    }
  }

  get_ImageOnFetchOne(IsMainItem: boolean) {
    if (IsMainItem) {
      var data = {
        SearchText: this.model.Barcode,
        GoogleApiKey: this.ds.Settings.GoogleApiKey,
        SearchEngineKey: this.ds.Settings.GoogleSearchEngineKey
      }
      this.isLoaded = false;
      this.pds.Get_ImageOnFetchOne(data).subscribe(res => {
        if (res.Success) {
          this.imageurl = res.data;
          this.model.ItemImagepath = res.data;
          this.isLoaded = true;
        }
        else {
          this.imageurl = this.DefaultImage;
          this.model.ItemImagepath = this.DefaultImage;
          this.isLoaded = true;
        }
      })
    }
    else {
      var data = {
        SearchText: this.Alternateunit.barcode,
        GoogleApiKey: this.ds.Settings.GoogleApiKey,
        SearchEngineKey: this.ds.Settings.GoogleSearchEngineKey
      }
      this.isLoaded = false;
      this.pds.Get_ImageOnFetchOne(data).subscribe(res => {
        if (res.Success) {
          this.Alternateunit.itemimagePath = res.data;
          if (this.SelectedRow.description != "" || this.SelectedRow.barcode != "") {
            this.model.Alternateunit.find(x => x.barcode == this.SelectedRow.barcode).itemimagePath = res.data;
          }
          else {
            document.getElementById("altbarcode").focus();
          }
          this.isLoaded = true;
        }
        else {
          this.Alternateunit.itemimagePath = this.DefaultImage;
          this.isLoaded = true;
        }
      })
    }
  }

  get_ImagesOnFetchImages(IsMainItem: boolean) {
    if (IsMainItem) {
      let d = this.dialogService
        .addDialog(ImageSelectComponent, { title: "Image List", text: this.model.Barcode })
        .subscribe(res1 => {
          if (res1.result) {
            this.imageurl = res1.item;
            this.model.ItemImagepath = res1.item;
          }
        });
    }
    else {
      let d = this.dialogService
        .addDialog(ImageSelectComponent, { title: "Image List", text: this.Alternateunit.barcode })
        .subscribe(res1 => {
          if (res1.result) {
            this.Alternateunit.itemimagePath = res1.item;
            if (this.SelectedRow.description != "" || this.SelectedRow.barcode != "") {
              this.model.Alternateunit.find(x => x.barcode == this.SelectedRow.barcode).itemimagePath = res1.item;
            }
            else {
              document.getElementById("altbarcode").focus();
            }
          }
        });
    }
  }

  get_DefaultImage() {
    var data = {
      SearchText: environment.baseUrl + "/images/noimage.png"
    }
    this.isLoaded = false;
    this.pds.Get_ImageAsBase64(data).subscribe(res => {
      if (res.Success) {
        this.DefaultImage = res.data;
        this.model.ItemImagepath = res.data;
        this.imageurl = res.data;
        this.Alternateunit.itemimagePath = res.data;
        this.isLoaded = true;
      }
      else {
        this.DefaultImage = "";
        this.isLoaded = true;
      }
    })
  }

  handleAltFileInput(files: FileList) {
    this.fileToUpload = <File>files.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.Alternateunit.itemimagePath = event.target.result;
      if (this.SelectedRow.description != "" || this.SelectedRow.barcode != "") {
        this.model.Alternateunit.find(x => x.barcode == this.SelectedRow.barcode).itemimagePath = event.target.result;
      }
      else {
        document.getElementById("altbarcode").focus();
      }
    }
    reader.readAsDataURL(this.fileToUpload);
  }

  AltImageUploaderChange(e) {
    if (this.AltImageUploaderValue == 1) {
      this.AltImageUp.nativeElement.value = "";
      this.AltImageUp.nativeElement.click();
    }
    else if (this.AltImageUploaderValue == 2) {
      this.get_ImageOnFetchOne(false);
    }
    else if (this.AltImageUploaderValue == 3) {
      this.get_ImagesOnFetchImages(false);
    }
    else if (this.AltImageUploaderValue == 4) {
      this.Alternateunit.itemimagePath = this.DefaultImage;
    }
  }

  selectItemOnClick(i, ix) {
    this.Alternateunit.itemimagePath = i.itemimagePath;
    this.SelectedIndex = ix;
    this.SelectedRow = i;
    this.AltImageUploaderValue = 0;
  }

  get_BarcodeOtherDetails(id) {
    var data = {
      LocId:this.ds.Settings.LocationId,
      Id:id
    }
    this.isLoaded = false;
    this.pds.Get_BarcodeOtherDetails(data).subscribe(res => {
      if (res.Success) {
        this.PromotionData = res.data;
        this.isLoaded = true;
      }
      else {
        this.PromotionData = "";
        this.isLoaded = true;
      }
    })
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/lazy-modules/+private-page/inventory/products/product-grp/product/product.component.ts